import { QuestionRequestJSON } from "./../questionPage/Question-Request.JSON";
import { QuestionOptionRequestJSON } from "./../questionPage/Question-Option-Request.JSON";
import { QuestionColumnRequestJSON } from "./../questionPage/Question-Column-Request.JSON";
import { LinkedQuestionJSON } from "./Linked-Question.JSON";

export class QuestionCardRequestJSON {
    linkedQuestion: boolean;
    questionTextJSON: QuestionRequestJSON;
    cardMessage: String;
    questionOptionJSONList: QuestionOptionRequestJSON[];
    questionColumnJSONList: QuestionColumnRequestJSON[];
    linkedCellTrackerMap: Map<Number,LinkedQuestionJSON[]>;
    priviledgeViewable: Boolean;
    priviledgeEditable: Boolean;
    rootLinkedQuestion : boolean;
    constructor(
    ) {
        this.linkedQuestion = false;
        this.cardMessage = "";
        this.questionTextJSON = new QuestionRequestJSON;
        this.questionOptionJSONList = new Array<QuestionOptionRequestJSON>();
        this.questionColumnJSONList = new Array<QuestionColumnRequestJSON>();
        this.linkedCellTrackerMap = new Map<Number, LinkedQuestionJSON[]>();
        this.rootLinkedQuestion = false;
    }
}